import { ContentBlock, StaticPage, Stored } from "../types";
import ApiModule from "./base";

export default class ContentBlocksModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "content_blocks");
  }

  async index(page: StaticPage): Promise<Array<Stored<ContentBlock>>> {
    const request = new Request(`${this.url}?page=${page}`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }
}
